<template>
    <div class="box-shadow">
    <form>
      <div class="col-sm-12">
        <h4 class="heading">FD Rates</h4>
        <div class="row">
          <div class="col-sm-2 form-group">
            <input type="text" placeholder="CCY" class="form-control" v-model="formData.ccy">
          </div>
          <div class="col-sm-2 form-group">
            <input type="text" placeholder="Amount" class="form-control" v-model="formData.amount">
          </div>  
          <div class="col-sm-2 form-group">
            <input type="text" placeholder="Tenure" class="form-control" v-model="formData.tenure">
          </div> 
          <div class="col-sm-2 form-group">
            <b-form-select  class="form-control" v-model="formData.account_number" :options="customers"></b-form-select>
          </div>
          <div class="form-group col-sm-2">
            <input type="text" name="fd_perc" class="form-control" placeholder="FD (%)" v-model="formData.fd_perc"/>
          </div>
          <div class="form-group col-sm-2">
            <button type="button" v-on:click="addFDRates" class="btn btn-sm btn-info">New</button> 
          </div>
        </div>   
      </div>
    </form>
  
    <form v-for="fd in tableData" :key="fd.id">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-2 form-group">
            <input type="text" placeholder="CCY" class="form-control" v-model="fd.ccy">
          </div>
          <div class="col-sm-2 form-group">
            <input type="text" placeholder="Amount" class="form-control" v-model="fd.amount">
          </div>  
          <div class="col-sm-2 form-group">
            <input type="text" placeholder="Tenure" class="form-control" v-model="fd.tenure">
          </div> 
          <div class="col-sm-2 form-group">
            <b-form-select  class="form-control" v-model="fd.account_number" :options="customers"></b-form-select>
          </div>
          <div class="form-group col-sm-2">
            <input type="text" name="fd_perc" class="form-control" placeholder="FD (%)" v-model="fd.fd_perc"/>
          </div>
          <div class="form-group col-sm-2">
            <button type="button" v-on:click="updateFDRates(fd)" class="btn btn-sm btn-info">Update</button> 
            <button type="button" v-on:click="deleteFDRates(fd.id)" class="btn btn-sm btn-info">Delete</button> 
          </div>
        </div>   
      </div>
    </form>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import common from '@/assets/js/common.js';
  import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
  
  export default {
    name: 'FDRateForm',
    props:['rows', 'formReRender'],
    components: { VueBootstrapTypeahead },
    mixins: [common],
    data(){
      return {
        customers: [{value:0, text:"All Accounts"}],
        formData: {
            'ccy': '',
            'amount': '',
            'tenure': '',
            'fd': '',
            'account_number': 0
        },
        tableData: [],
        refreshView: false,
        errorMessage: null,
      };
    },
    methods: {
        async getData() {
            let uri = 'fd_rates'
            await this.call_axios(uri).then(({response}) => {
                this.tableData = response.data.result;
            }); 
        },
        addFDRates: async function(){
            const {response} = await this.call_axios('fd_rates', 'post', this.formData); 
            this.$toasted.success("Successfully Added",{duration:1000});    
            this.formReRender(response);
        },
        updateFDRates: async function(fd){
            const {response} = await this.call_axios('fd_rates/'+fd.id, 'put', fd); 
            this.$toasted.success("Successfully Updated",{duration:1000});    
            this.formReRender(response);
        },
        deleteFDRates: async function(fd_id){
            const {response} = await this.call_axios('fd_rates/'+fd_id, 'delete'); 
            this.$toasted.success("Successfully Deleted",{duration:1000});    
            this.formReRender(response);
        },
        async getCustomer() {
            let uri = 'customer_account_list';
            this.call_axios(uri).then(({response}) => {
                //this.customers = this.customers.concat(response.data.result);
                response.data.result.forEach((val) => {
                  this.customers.push({value: val, text: val});
                })
            });     
        },
    },
    mounted(){
  
    },
    created(){
        this.getCustomer();
        this.getData();
    }
  };
  </script>